import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { AppUpdateService } from "@core/services/app-update.service";
import { IconComponent } from "@shared/components/ui/icon/icon.component";

@Component({
  selector: "app-update-banner",
  imports: [IconComponent],
  templateUrl: "./app-update-banner.component.html",
  styleUrl: "./app-update-banner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateBannerComponent {
  readonly updates = inject(AppUpdateService);

  reload(): void {
    this.updates.reloadForUpdate();
  }
}
